import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { UI } from "../../services/ui.service";
import { UserService } from "../../domain/user-service";
import { Logger } from "../../infrastructure/logger";
import { DynamicPromo, DynamicPromoInfo } from "../../domain/dyanmicPromo";
import { WizardStepComponent } from "../common/wizard/wizard-step.component";
import { DynamicPromoRepository } from "../../domain/dynamic-promo-repository";
import libraryStore from "../../services/stores/library.store";
import { SearchService } from "../../services/search.service";
import { NavigationItemModel } from "../common/sideNav/navigationItem.model";
import { MediaInfo, MediaItem } from "../../domain/media";
import { MediaRepository } from "../../domain/media-repository";
import { GraphicsRepository } from "../../domain/graphics-repository";
import { GraphicsInfo } from "../../domain/graphics-info";

@Component({
  selector: "icn-dynamic-promo-create-edit",
  templateUrl: "./dynamic-promo-create-edit.html",
  styleUrls: ["./dynamic-promo-create-edit.scss"],
})
export class DynamicPromoCreateEditComponent implements OnInit, OnDestroy {
  constructor(
    private logger: Logger,
    private route: ActivatedRoute,
    private userService: UserService,
    private changeDetectorRef: ChangeDetectorRef,
    private ui: UI,
    private dynamicPromoRepository: DynamicPromoRepository,
    private searchService: SearchService,
    private mediaRepository: MediaRepository,
    private graphicsRepository: GraphicsRepository,
    private router: Router,
  ) {}

  mediaNavigation = new NavigationItemModel("video", "video-icon", "media");
  graphicsNavigation = new NavigationItemModel(
    "graphics",
    "graphics-icon",
    "graphics",
  );
  libraryStore = libraryStore;
  dynamicPromoInfo: DynamicPromoInfo;
  chosenPromoMediaId: number = -1;
  isScheduled = false;
  edit = false;
  videoUrl = "";
  previewData: VideoPreviewData;
  chooseGraphicClicked = false;
  chooseMediaClicked = false;
  mediaIcon = "/assets/icons/media-icon.svg";
  graphicsIcon = "/assets/icons/graphics-icon.svg";
  isLoadingFinished: boolean = false;

  getHeader() {
    if (this.edit && !!this.dynamicPromoInfo) {
      return this.dynamicPromoInfo.name;
    }
    return "CREATE DYNAMIC PROMO";
  }

  ngOnInit() {
    this.subscribeToRoute();
  }

  ngOnDestroy() {}

  createDynamicPromo() {
    if (
      this.dynamicPromoInfo.graphicsInfo === null ||
      this.dynamicPromoInfo.mediaInfo === null
    ) {
      return;
    }
    let trailerId = null;
    if (this.dynamicPromoInfo.trailerId) {
      trailerId = this.dynamicPromoInfo.trailerId;
    } else if (
      this.dynamicPromoInfo.mediaInfo.trailers &&
      this.dynamicPromoInfo.mediaInfo.trailers[0]
    ) {
      console.log(
        "createDynamicPromo-> trailer is ",
        this.dynamicPromoInfo.mediaInfo.trailers[0],
      );
      trailerId = this.dynamicPromoInfo.mediaInfo.trailers[0].id;
    }

    if (trailerId != null) {
      this.chosenPromoMediaId = trailerId;
    }

    let startGraphicOffsetSeconds = 5; //the default is 5 seconds
    if (this.dynamicPromoInfo.startGraphicOffsetSeconds) {
      startGraphicOffsetSeconds =
        this.dynamicPromoInfo.startGraphicOffsetSeconds;
    }
    let dynamicPromo: DynamicPromo = new DynamicPromo(
      this.dynamicPromoInfo.id,
      this.dynamicPromoInfo.name,
      this.dynamicPromoInfo.graphicsInfo.id,
      this.dynamicPromoInfo.mediaInfo.id,
      this.dynamicPromoInfo.thumbnail,
      startGraphicOffsetSeconds,
      trailerId,
    );
    this.dynamicPromoRepository
      .createDynamicPromo(dynamicPromo)
      .then((dynamicPromo: DynamicPromo) => {
        this.router.navigate([
          "/scheduler/dynamicPromo/edit/",
          dynamicPromo.id,
        ]);
      })
      .catch((err) => {
        if (err.status === 400) {
          this.ui.notify(this.ui.EVENTS.ShowAlert, {
            title: "Dynamic Promo",
            message: "An error occurred",
          });
        }
        throw err;
      });
  }

  updateDynamicPromo() {
    this.dynamicPromoRepository
      .updateDynamicPromo(this.dynamicPromoInfo)
      .then((dynamicPromo: DynamicPromo) => {
        this.initDynamicPromo(dynamicPromo.id);
      })
      .catch((err) => {
        if (err.status === 400) {
          this.ui.notify(this.ui.EVENTS.ShowAlert, {
            title: "Dynamic Promo",
            message: "An error occurred",
          });
        }
        throw err;
      });
  }

  onPromoMediaChanged(mediaId) {
    if (mediaId == -1) {
      this.dynamicPromoInfo.trailerId = null;
    } else {
      this.dynamicPromoInfo.trailerId = mediaId;
    }

    let videoPreviewMediaId: number =
      mediaId == -1
        ? this.dynamicPromoInfo.mediaInfo.id
        : this.dynamicPromoInfo.trailerId;
    this.initVideoPreview(videoPreviewMediaId).then(() => {
      this.changeDetectorRef.markForCheck();
    });
  }

  onNextHandler(event) {
    let previousStep: WizardStepComponent = event.previousStep;
  }

  onBackHandler(event) {
    let previousStep: WizardStepComponent = event.previousStep;
  }

  private subscribeToRoute() {
    this.route.params.subscribe((params: Params) => {
      console.log("subscriveToRoute");
      if (!!params["id"]) {
        this.initDynamicPromo(params["id"]);
      } else {
        this.edit = false;
        this.dynamicPromoInfo = new DynamicPromoInfo(
          null,
          "",
          null,
          null,
          null,
          null,
          null,
        );
        this.isLoadingFinished = true;
        this.changeDetectorRef.markForCheck();
      }
    });
  }

  initDynamicPromo(id) {
    this.dynamicPromoRepository
      .getDynamicPromo(id)
      .then((dynamicPromo) => {
        this.mediaRepository
          .getMediaInfo(dynamicPromo.mediaId)
          .then((mediaInfo) => {
            this.graphicsRepository
              .getGraphics(dynamicPromo.graphicsId)
              .then((graphicsInfo) => {
                this.dynamicPromoInfo = new DynamicPromoInfo(
                  dynamicPromo.id,
                  dynamicPromo.name,
                  graphicsInfo,
                  mediaInfo,
                  dynamicPromo.thumbnail,
                  dynamicPromo.startGraphicOffsetSeconds,
                  dynamicPromo.trailerId,
                );
                this.isScheduled = dynamicPromo.isScheduled;
                this.chosenPromoMediaId = -1;
                this.changeDetectorRef.markForCheck();

                this.edit = true;
                console.log("choosen dynamic item", dynamicPromo);

                if (dynamicPromo.trailerId) {
                  this.chosenPromoMediaId = dynamicPromo.trailerId;
                  this.initVideoPreview(dynamicPromo.trailerId).then(() => {
                    this.isLoadingFinished = true;
                    this.changeDetectorRef.markForCheck();
                  });
                } else {
                  this.chosenPromoMediaId = -1;
                  this.initVideoPreview(dynamicPromo.mediaId).then(() => {
                    this.isLoadingFinished = true;
                    this.changeDetectorRef.markForCheck();
                  });
                }
              });
          });
      })
      .catch((err) => {
        this.logger.warn("Error getting dynamic promo. Error: " + err);
      });
  }

  chooseGraphic() {
    this.libraryStore.setLibraryType(this.graphicsNavigation.storeKey());
    this.searchService.searchMode = this.graphicsNavigation.storeKey();
    this.searchService.subjectModeNext();
    if (!this.dynamicPromoInfo.mediaInfo) {
      this.chooseMediaClicked = false;
      this.onMediaMouseLeave();
    }
    this.chooseGraphicClicked = true;
    this.onGraphicsMouseEnter();
  }

  chooseMedia() {
    this.libraryStore.setLibraryType(this.mediaNavigation.storeKey());
    this.searchService.searchMode = this.mediaNavigation.storeKey();
    this.searchService.subjectModeNext();
    if (!this.dynamicPromoInfo.graphicsInfo) {
      this.chooseGraphicClicked = false;
      this.onGraphicsMouseLeave();
    }
    this.chooseMediaClicked = true;
    this.onMediaMouseEnter();
  }

  onMediaMouseEnter() {
    let mediaContainer = document.getElementById("media-container");
    mediaContainer && mediaContainer.classList.add("choose-media-clicked");
    this.mediaIcon = "/assets/icons/media-icon-plus.svg";
  }

  onMediaMouseLeave() {
    if (!this.chooseMediaClicked) {
      let mediaContainer = document.getElementById("media-container");
      mediaContainer && mediaContainer.classList.remove("choose-media-clicked");
      this.mediaIcon = "/assets/icons/media-icon.svg";
      console.log("dynamicPromo -> onMediaMouseLeave event");
    }
  }

  onGraphicsMouseEnter() {
    let graphicsContainer = document.getElementById("graphics-container");
    graphicsContainer &&
      graphicsContainer.classList.add("choose-graphics-clicked");
    this.graphicsIcon = "/assets/icons/graphics-icon-plus.svg";
  }

  onGraphicsMouseLeave() {
    if (!this.chooseGraphicClicked) {
      let graphicsContainer = document.getElementById("graphics-container");
      graphicsContainer &&
        graphicsContainer.classList.remove("choose-graphics-clicked");
      this.graphicsIcon = "/assets/icons/graphics-icon.svg";
    }
  }

  onDragEnter(e) {}

  onDragLeave(e) {}

  onGraphicDropped(event) {
    if (!!event) {
      let graphicsInfo: GraphicsInfo = JSON.parse(
        event.dataTransfer.getData("text/graphics"),
      );
      if (!graphicsInfo) {
        return;
      }

      if (this.isScheduled) {
        this.ui.notify(this.ui.EVENTS.ShowAlert, {
          title: "Dynamic Promo",
          message:
            "Error! Can't replace graphics since the dynamic promo has been already scheduled!",
        });
        return;
      }
      this.graphicsRepository
        .getGraphicsTemplate(graphicsInfo.id)
        .then((result) => {
          this.dynamicPromoInfo.graphicsInfo = result;
          if (
            this.dynamicPromoInfo.mediaInfo !== null &&
            this.dynamicPromoInfo.mediaInfo.trailers !== null &&
            this.dynamicPromoInfo.mediaInfo.trailers.filter(
              (x) => x.contentUploadStatus === 0,
            ).length > 0
          ) {
            this.mediaRepository
              .getMediaInfo(
                this.dynamicPromoInfo.mediaInfo.trailers.filter(
                  (x) => x.contentUploadStatus === 0,
                )[0].id,
              )
              .then((trailerInfo) => {
                if (
                  this.dynamicPromoInfo.graphicsInfo.durationMS >
                  trailerInfo.contentDuration.asMilliseconds()
                ) {
                  this.ui.notify(this.ui.EVENTS.ShowAlert, {
                    title: "Dynamic Promo",
                    message:
                      "Warning, the selected graphic is longer than the selected media trailer",
                  });
                }
              });
          }
          this.changeDetectorRef.markForCheck();
        });
    }
  }

  onMediaDropped(event) {
    if (!!event) {
      let media: MediaItem = JSON.parse(
        event.dataTransfer.getData("text/media"),
      );
      if (!media) {
        return;
      }
      if (this.isScheduled) {
        this.ui.notify(this.ui.EVENTS.ShowAlert, {
          title: "Dynamic Promo",
          message:
            "Error! Can't replace media since the dynamic promo has been already scheduled!",
        });
        return;
      }
      this.dynamicPromoInfo.name = "Promo for " + media.name;
      this.mediaRepository.getMediaInfo(media.id).then((mediaInfo) => {
        this.dynamicPromoInfo.mediaInfo = mediaInfo;
        if (
          (mediaInfo.trailers === null ||
            (mediaInfo.trailers !== null &&
              mediaInfo.trailers.filter((x) => x.contentUploadStatus === 0)
                .length === 0)) &&
          (mediaInfo.contentSnapshotUrl === null ||
            mediaInfo.contentSnapshotUrl === "")
        ) {
          this.ui.notify(this.ui.EVENTS.ShowAlert, {
            title: "Dynamic Promo",
            message: "Warning! no trailer or packshot available for this media",
          });
        } else if (
          this.dynamicPromoInfo.graphicsInfo !== null &&
          mediaInfo.trailers !== null &&
          mediaInfo.trailers.filter((x) => x.contentUploadStatus === 0).length >
            0
        ) {
          this.mediaRepository
            .getMediaInfo(
              mediaInfo.trailers.filter((x) => x.contentUploadStatus === 0)[0]
                .id,
            )
            .then((trailerInfo) => {
              if (
                this.dynamicPromoInfo.graphicsInfo.durationMS >
                trailerInfo.contentDuration.asMilliseconds()
              ) {
                this.ui.notify(this.ui.EVENTS.ShowAlert, {
                  title: "Dynamic Promo",
                  message:
                    "Warning, the selected graphic is longer than the selected media trailer",
                });
              }
            });
        }
        this.changeDetectorRef.markForCheck();
      });
    }
  }

  private canSaveDynamicPromo() {
    return true;
  }

  private initVideoPreview(videoMediaId: number) {
    return this.mediaRepository
      .getMediaInfo(videoMediaId)
      .then((previewMediaInfo) => {
        this.mediaRepository
          .getMediaPreviewUrl(previewMediaInfo.id)
          .then((result) => {
            this.previewData = new VideoPreviewData(previewMediaInfo, result);
          });
      });
  }
}

class VideoPreviewData {
  constructor(
    public mediaInfo: MediaInfo,
    public previewUrl: string,
  ) {}
}
